import React from 'react';
import { ArrowRight, ShieldCheck, CreditCard, Lock } from 'lucide-react';
export function PurchaseSection() {
  const checkoutUrl = 'https://checkout.ilumente.online/checkouts/cn/hWN6uJYr1zFnLXEXpMN1SEIU/es-ar?_r=AQABH-Rpqn2kPmFK0jHKFWrAicZ8CmEjTS8Cc8_zVJH_QgQ&preview_theme_id=183314547000';
  return <section id="purchase" className="py-20 px-4 relative overflow-hidden border-t border-green-500/20" data-id="element-81">
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900 to-black" data-id="element-82" />
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-20" data-id="element-83" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-84">
        <div className="mb-8" data-id="element-85">
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-4 tracking-wide leading-tight" data-id="element-86">
            EMPEZÁ HOY MISMO
          </h2>
          <p className="text-xl text-slate-300" data-id="element-87">
            Acceso inmediato a la guía completa + Todos los bonos
          </p>
        </div>

        {/* BLOQUE INTEGRADO: Imagen + Precio */}
        <div className="bg-slate-800/50 border-2 border-green-500/50 rounded-2xl p-6 md:p-8 shadow-[0_0_50px_rgba(34,197,94,0.15)] relative overflow-hidden backdrop-blur-sm" data-id="element-88">
          {/* Discount badge */}
          <div className="absolute top-0 right-0 bg-red-600 text-white text-sm font-bold px-4 py-1 rounded-bl-xl z-20" data-id="element-89">
            OFERTA ESPECIAL
          </div>

          {/* Product Image */}
          <div className="mb-8 flex justify-center" data-id="element-90">
            <div className="relative max-w-xs sm:max-w-sm" data-id="element-91">
              <div className="absolute inset-0 bg-green-500/20 blur-[80px]" data-id="element-92" />
              <img src="https://cdn.magicpatterns.com/uploads/eN7fRDDkwak2ta26ndZn55/ChatGPT_Image_27_dic_2025,_04_18_37.png" alt="Cómo empezar a ganar dinero extra ya" className="relative z-10 w-full drop-shadow-2xl" data-id="element-93" />
            </div>
          </div>

          {/* Precio */}
          <div className="flex flex-col items-center justify-center mb-8" data-id="element-94">
            <span className="text-slate-400 text-lg line-through mb-2" data-id="element-95">
              $39.990
            </span>
            <div className="flex items-start" data-id="element-96">
              <span className="text-3xl font-bold text-green-500 mt-2" data-id="element-97">$</span>
              <span className="text-6xl sm:text-7xl font-bold text-white" data-id="element-98">
                19.990
              </span>
            </div>
            <span className="text-green-400 font-medium mt-2" data-id="element-99">
              Pago único • Acceso de por vida
            </span>
          </div>

          {/* Botón de compra */}
          <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="group relative w-full block bg-gradient-to-r from-green-600 to-green-500 hover:from-green-500 hover:to-green-400 text-white text-xl sm:text-2xl font-bold py-5 sm:py-6 px-6 sm:px-8 rounded-xl shadow-lg transition-all transform hover:scale-[1.02] hover:shadow-green-500/25 mb-6 overflow-hidden" data-id="element-100">
            <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-101" />
            <span className="flex items-center justify-center gap-3" data-id="element-102">
              ACCEDER AHORA
              <ArrowRight className="w-5 h-5 sm:w-6 sm:h-6 group-hover:translate-x-1 transition-transform" data-id="element-103" />
            </span>
          </a>

          {/* Trust badges */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 text-sm text-slate-400" data-id="element-104">
            <div className="flex items-center gap-2" data-id="element-105">
              <Lock className="w-4 h-4" data-id="element-106" />
              Pago 100% Seguro
            </div>
            <div className="flex items-center gap-2" data-id="element-107">
              <ShieldCheck className="w-4 h-4" data-id="element-108" />
              Garantía de Satisfacción
            </div>
            <div className="flex items-center gap-2" data-id="element-109">
              <CreditCard className="w-4 h-4" data-id="element-110" />
              Acceso Inmediato
            </div>
          </div>
        </div>

        <div className="mt-12 text-slate-400 text-sm max-w-2xl mx-auto" data-id="element-111">
          <p data-id="element-112">
            Al hacer clic en el botón serás redirigido a nuestra pasarela de
            pago segura. Una vez confirmado el pago, recibirás un correo
            electrónico con tus datos de acceso para descargar todo el material
            inmediatamente.
          </p>
        </div>
      </div>
    </section>;
}